// window.grecaptcha is created by the grecaptcha script
// loaded in <head>
declare global {
  interface Window {
    grecaptcha: {
      ready: (callback: () => void) => void;
      execute: (key: string, action: { action: string }) => PromiseLike<string>;
    };
  }
}

const activeEnv = process.env.GATSBY_ACTIVE_ENV || process.env.NODE_ENV || 'development';

export const getRecaptchaToken = (): Promise<string> =>
  new Promise((resolve, reject) => {
    if (activeEnv === 'test') {
      resolve('testToken');
      return;
    }

    window.grecaptcha.ready(async () => {
      const key = process.env.GATSBY_RECAPTCHA_SITE_KEY;
      if (key === undefined) {
        reject(new Error('reCAPTCHA key not found'));
        return;
      }

      resolve(await window.grecaptcha.execute(key, { action: 'submit' }));
    });
  });
